import { StandardStrapiFields } from '../strapi/strapi'
import UserAudit from './components/audit/user-audit'
import ShipmentsLacquer from './components/shipments-lacquer'
import Contractor from './contractor'
import Machine from './machine'
import Material from './material'
import MaterialType from './material-type'
import ShipmentPosition from './shipment-position'
import Stamp from './stamp'
import User from './user'
import { MaterialRequirement } from './components/material/material-requirements'
import Task from './task'
import UploadedFile from './uploaded-file'
import Color from './components/shipment/color'
import FormSet from './form-set'
import AdditionalJob from './additional-job'
import Calculated from './components/calculation-position/calculated'
import { VirtualStamp } from './components/stamps/virtual-stamp'
import type PrintJob from './print-job'
import { PrintedFormSetSnapshot } from './components/shipment/printed-form-set-snapshot'
import FormOrder from './form-order'
import type Order from './order'
import type { ShipmentType } from './shipment-type'

export default interface Shipment extends StandardStrapiFields {
    comment: string
    shipment_positions?: ShipmentPosition[]
    client?: Contractor
    order?: Order
    // created_by_user?: User
    stamp?: Stamp // Ссылка на высечной нож
    material?: Material // Ссылка на материал
    whitewash?: number // Белила, определенный вид краски
    cmyk?: number // Цветность по модели CMYK
    pantones?: number // Кол-во цветов по модели Pantones, цвета из веера цветов (готовые краски не требуют смешения)
    sellingPrice?: number // Отпускная цена за 1 штуку
    additional_material_types?: MaterialType[] // Ссылка на типы дополнительных материалов
    additional_materials?: Material[] // Ссылка на дополнительные материалы
    quantityPerRoll?: number // Кол-во этикеток в рулоне, важно на этапе перемотки
    windingInfo?: string // Свободный текст по намотке, выводится в бланках рядом с количеством
    designer?: User // Дизайнер, который будет обрабатывать отгрузку, возможно нужно вынести в отгрузки
    windingSchemeFace?: Windings // Схема намотки лицевой стороны
    windingSchemeTurn?: Windings // Схема намотки оборотной стороны
    package: Package // Упаковка
    packageCopies: PackageCopies // Признак того, что если напечатают больше, то клиент все заберет, или же ему нужно только строгое кол-во
    manualLabeling: boolean // Признак того, что этикетки будут клеится клиентом вручную или автоматически
    clientLabel: boolean // Признак того, как упаковать, использовать ли этикетку гаммы или клиентскую, скотч и прочее (бывают перекупы, они подставляют свои лейблы и там не слово о компании гамма)
    pallet: Pallets // Это типа ящики какие с коробками
    congreve: boolean // Признак специальной обработки
    priming: boolean // Признак специальной обработки матриала до печати, например пленки
    bushing: number // Втулка на которую наматывать ролики
    printingOnGlueLayer?: boolean // Печать на клеевом слое
    printWithCurator?: boolean // Печать с куратором
    preferred_machine?: Machine // Предпочитаемый станок для печати, тут немного переиграется
    // priorityMachineName?: string
    lacquers?: ShipmentsLacquer[] // Список компонентов с типами лака с наименованиями
    lacquersDms?: number // кол-во лаков в DMS
    user_audit?: UserAudit
    created_by_user?: User
    // machine_brands?: MachineBrand[]
    materialRequirements?: MaterialRequirement[] // Список необходимых материалов для печати
    tasks?: Task[]
    blankPreviewFiles?: UploadedFile[] // Файл с превью этикеток, .pdf
    honestSignsCodesFile?: UploadedFile[] // Файлы с кодами для "честного знака"
    colors?: Color[]
    clientDeliveryDate?: string
    materialsOrdered?: boolean
    executedAt?: string | null
    /** Статус согласования куратором: не задано = ожидает; Согласован | Отклонено */
    approved?: ShipmentApprovedStatus | null
    paintCostOf1000DurstWG?: number
    currencyRate?: number
    stampFloods?: number
    numberOfForms?: number
    form_set?: FormSet
    printedFormSetSnapshot?: PrintedFormSetSnapshot // слепок набора форм при завершении печати
    machine?: Machine
    additional_machines?: Machine[]
    additional_jobs?: AdditionalJob[]
    print_job?: PrintJob
    calculated?: Calculated
    calculatedOnActual?: Calculated // Фактический расчёт после фиксации расхода
    withoutCutting?: boolean // Без высечки и штампа
    deal?: boolean
    virtualStamp?: VirtualStamp // Виртуальный штамп
    sourceFile: UploadedFile[] // Общие исходники на все виды
    form_orders?: FormOrder[] // Связанные заказы форм
    shipmentType?: ShipmentType
    /** null и true — оснастка в себестоимости. false — отдельная позиция заказа. */
    stampIncludedInCost?: boolean | null
    formsIncludedInCost?: boolean | null
}

export type ShipmentApprovedStatus = 'Согласован' | 'Отклонено'

export enum Windings {
    A = 'a',
    B = 'b',
    C = 'c',
    D = 'd',
    E = 'e',
    F = 'f',
    G = 'g',
    H = 'h',
    I = 'i',
}

export const windingDisplay: Record<Windings, string> = {
    [Windings.A]: '1',
    [Windings.B]: '2',
    [Windings.C]: '3',
    [Windings.D]: '4',
    [Windings.E]: '5',
    [Windings.F]: '6',
    [Windings.G]: '7',
    [Windings.H]: '8',
    [Windings.I]: '9',
}

export const windingsDisplay = (value?: Windings | null) => (value ? windingDisplay[value] : '—')

export enum PackageCopies {
    Strictly = 'strictly',
    NotStrictly = 'notStrictly',
}

export enum Pallets {
    Euro = 'euro',
    Any = 'any',
    No = 'no',
}

export type Package = 'Стретч' | 'Стретч+гофро' | 'Стретч+гофро+паллет' | 'Стретч+паллет' | 'Короб'
